module.exports = __webpack_public_path__ + "img/snezana_d.b28bbcda.png";